import React from 'react';
import Style from './index.module.css';

const CompleteProfileModal = ({ onClose, onSkip }) => {
  return (
    <div className={Style.overlay}>
      <div className={Style.modal}>
        <h2 className={Style.header}>Complete Your Profile</h2>
        <p className={Style.message}>
          Please complete your profile before posting an advertisement.
        </p>
        <div className={Style.actions}>
          <button className={Style.primaryButton} onClick={onClose}>
            Go to Profile
          </button>
          <button className={Style.secondaryButton} onClick={onSkip}>
            Remind Me Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompleteProfileModal;
